export default {
  today: "Aujourd'hui",
  tomorrow: 'Demain',
};
